<template>
  <div  v-if="show" style="display:block;margin-left: 10px;">
    <div v-for="(item,index) in params.questionModel.relationQuestion" :key="item.model">
      {{item.name}}
      <el-radio-group
        v-model="params.bindModel[item.model]"
        :label="item.name"
        :key="item.model + index"
        :style="{'display':'block','padding-left':'15px'}"
      >
        <el-radio
          :style="{display: 'block'}"
          v-for="childopitem in item.options.options"
          :key="childopitem.value+index"
          :label="childopitem.value"
        >{{childopitem.label}}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "relation",
  data() {
    return {
      show: false,
      params: {}
    };
  },
  methods: {
    updatedData(data) {
      this.params = data;
      if (
        data.questionModel.relationQuestion &&
        data.questionModel.relationQuestion.length > 0
      ) {
        this.show = true;
      } else {
        this.show = false;
      }

    }
  },
  created() {}
};
</script>


// WEBPACK FOOTER //
// src/components/draggleForm/GenerateFormItemRelation.vue